import React from 'react';

interface ApplyButtonProps {
  onApply: () => void;
}

const ApplyButton = ({ onApply }: ApplyButtonProps) => {
  return (
    <div
      className="py-1 mt-1 border-t border-control text-sm text-center font-semibold rounded-b cursor-pointer hover:bg-hover"
      onClick={onApply}
    >
      Apply
    </div>
  );
};

export default ApplyButton;
